import { render, staticRenderFns } from "./AddBuyerModal.vue?vue&type=template&id=6a2b8862&scoped=true"
import script from "./AddBuyerModal.vue?vue&type=script&lang=js"
export * from "./AddBuyerModal.vue?vue&type=script&lang=js"
import style0 from "./AddBuyerModal.vue?vue&type=style&index=0&id=6a2b8862&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b8862",
  null
  
)

export default component.exports